/* tslint:disable */
import * as React from 'react';
import {Form, FieldArray, formValueSelector, reduxForm} from 'redux-form';
import {flow, get} from 'lodash';
import {Button, Col, Row} from 'react-bootstrap';
import {IPolicyApplication, IProduct} from '../../../../data/api/models';
import FaChevronRight from 'react-icons/fa/chevron-right';
import TravellersInfo from './components/TravellersInfo';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {bindActionCreators} from 'redux';
import {IStore} from '../../../../redux/IStore';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteState, IQuoteActions} from '../../../../services/quote/models';
import Signpost from '../SchemeChoice/components/Signpost';
import TripInfo from './components/TripInfo';
import {IReactStep} from '../../steps';
import {RouteComponentProps} from 'react-router';
import {scrollToFirstError} from '../../../../util/scrollToFirstError';

interface IPersonalDetailsProps extends RouteComponentProps<any> {
    onBack: () => void;
    handleSubmit: () => void;
    steps: IReactStep[];
    change: any;
    product: IProduct;
    i18n: II18nMessages;
    groupType: string;
    channel: any;
    tripType: string;
    quote: IQuoteState;
    actions: {
        quote: IQuoteActions;
        push: (route: string) => void;
    };
}

class PersonalDetails extends React.Component<IPersonalDetailsProps> {
    private unableToProvideQuoteMessage = () => {
        const {channel, quote} = this.props;

        if (quote.isCalculating || quote.isSignposting) {
            return;
        }

        if (quote.signpost) {
            return (
                <div style={{padding: '20px', backgroundColor: '#f6f6f6'}}>
                    <Signpost signpost={quote.signpost} channel={channel}/>
                </div>
            );
        }

        return (
            <div style={{padding: '20px', backgroundColor: '#f6f6f6'}}>
            <span>
              Sorry, we are not able to complete your quotation online as we need a few more details.<br/><br/>
              Simply call our UK-based specialist customer service team on {channel.phone} quoting
                {' '}<strong>{quote.application.quoteReference}</strong> who will discuss your requirements with you.
              <br/><br/>We are open Monday to Friday Monday – Friday 8am – 6pm, closed Bank Holidays.
            </span>
            </div>
        );
    }

    private safePush = (to: string) => {
        const { location, actions } = this.props;
        if (location && location.pathname !== to) {
            actions.push(to);
        }
    }

    private scrollToTop = () => {
        if (process.env.BROWSER) {
            window.scrollTo(0, 0);
        }
    }

    private editTripDetails = () => {
        const { steps } = this.props;
        this.safePush(steps[0].route);
        this.scrollToTop();
    }

    public render() {
        const {handleSubmit, onBack, product,
               i18n, groupType, channel, quote} = this.props;
        const errors = get(quote, 'application.premiums[0].errors.length', 0) > 0;

        return (
            <div>
                {!errors ? (
                    <Form onSubmit={handleSubmit} autoComplete="off">
                        <div className="steps-container">
                            <div className="section-title">
                                <h1>Your Confirmation</h1>
                            </div>
                            <strong>Please confirm the below details are filled in correctly.</strong>
                            <Row>
                                <Col sm={12} lg={8}>
                                    <FieldArray
                                        name="tripDetails"
                                        component={TripInfo}
                                        quote={quote}
                                        change={this.props.change}
                                    />
                                </Col>
                                <Col sm={12} lg={4}>
                                    <button
                                        onClick={this.editTripDetails}
                                        className="option-btn pull-right"
                                        style={{
                                            cursor: quote.isCalculating
                                                ? 'default'
                                                : 'pointer',
                                            textAlign: 'center',
                                            padding: '10px',
                                            color: '#fff',
                                            borderRadius: '5px',
                                            border: 'none',
                                            marginTop: '20px',
                                            fontSize: '13px'
                                        }}
                                    >
                                        Edit Trip Details
                                    </button>
                                </Col>
                            </Row>
                            <div className="border-at-bottom" />


                            <FieldArray
                                name="travellers"
                                i18n={i18n}
                                channel={channel}
                                product={product}
                                test={'test'}
                                component={TravellersInfo}
                                groupType={groupType}
                                change={this.props.change}
                            />
                            {quote.signpost && (
                                <div>
                                    <Signpost signpost={quote.signpost} channel={channel}/>
                                </div>
                            )}
                            <section>
                                <p>Please be aware that your policy is not a private medical insurance policy,
                                    and does not cover private medical treatment, private hospital costs or other
                                    related expenses incurred unless these have been specifically agreed and approved
                                    by the Medical Assistance Company.</p>
                            </section>
                            <div className="btn-bar margin-top">
                                <Button
                                    bsStyle="primary"
                                    type="submit"
                                    className="pull-right btn-remove-border"
                                    // disabled={submitting || (submitFailed && !valid)}
                                >
                                    {(channel.key === 'csis-b2c' || channel.key === 'tpl-b2c' || channel.key === 'camc-b2c') ? (
                                        <>
                                            Continue to next step <FaChevronRight/>
                                        </>
                                    ) : (
                                        <>Continue <FaChevronRight/></>
                                    )}
                                </Button>
                                <Button type="button" className="btn-back btn-remove-border" onClick={onBack}>
                                    Back
                                </Button>
                            </div>

                        </div>
                    </Form>
                ) : (
                    <div>
                        {this.unableToProvideQuoteMessage()}
                    </div>
                )}
            </div>
        );
    }
}

let selector;
let previousValues;

export default flow([
    reduxForm({
        form: 'quote',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        onSubmitFail: () => {
            setTimeout(() => scrollToFirstError({ offset: 120 }), 0);
        },
        onChange: (
            values: IPolicyApplication,
            dispatch,
            props: IPersonalDetailsProps,
        ) => {
            if (!previousValues) {
                previousValues = values;
                return;
            }

            previousValues = values;
        },
    }),
    (component) => {
        selector = formValueSelector('quote');

        return component;
    },
    connect(
        (state: IStore) => {
            const tripType = selector(state, 'tripType');
            const groupType = selector(state, 'groupType');
            const startDate = selector(state, 'startDate');
            const endDate = selector(state, 'endDate');
            const destinationsValue = selector(state, 'destinations');
            const occupationValue = selector(state, 'occupations');
            const industryValue = selector(state, 'industries');
            const region = selector(state, 'region');
            const maxTripDuration = selector(state, 'maxTripDuration');
            const residency = selector(state, 'residency');
            const quotationTypes = selector(state, 'quotationTypes');
            const vehicleReg = selector(state, 'vehicleReg');

            return {
                tripType,
                quotationTypes,
                residency,
                region,
                maxTripDuration,
                groupType,
                startDate,
                endDate,
                destinationsValue,
                occupationValue,
                industryValue,
                vehicleReg,
                auth: state.auth,
                channel: state.branding.channel,
            };
        },
        (dispatch) => ({
            actions: {
                quote: bindActionCreators({...quoteActions}, dispatch),
                push: bindActionCreators(push, dispatch),
            },
        }),
    ),
])(PersonalDetails);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/PersonalDetailsB/index.tsx